import { useRef, useState } from "react";

import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import useSecretariaFetch from "./useSecretariaFetch";
import { Secretaria } from "../../types/secretaria/Secretaria";


type Props = {
    isdisabled?: boolean;
    isLoading?: boolean;
    required?: boolean;
    value?: Secretaria | null;
    handleSearchChange: (newValue: Secretaria) => void;
};


const TxtSecretaria = ({
    isdisabled,
    isLoading,

    required,
    value,
    handleSearchChange,

}: Props) => {


    const timeoutRef = useRef<number | null>(null);
    const loading = useRef(false);




    const handleSetLoad = (newValue: boolean) => {
        loading.current = newValue;
    };

    const [inputValue, setInputValue] = useState("");
    const { options } = useSecretariaFetch({ inputValue, handleSetLoad });


    return (
        <Autocomplete
            value={value && value.id ? value : null} // 
            size="small"
            options={options}
            isOptionEqualToValue={(option, value) => option.id === value.id}

            getOptionLabel={(option) => {
                const secretaria = option as Secretaria;
                if (!secretaria) {
                    return "";
                }

                let descricao: string = "";
               

                if (secretaria.orgao?.abreviatura) {
                    descricao = secretaria.orgao.abreviatura;

                }
                if (secretaria.nome) {
                    descricao  += " - "+secretaria.nome;
                }




                return descricao;
            }}
            loading={loading.current}

            onInputChange={(event, newInputValue) => {

                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                timeoutRef.current = window.setTimeout(() => {
                    setInputValue(newInputValue);


                }, 700); // 300ms delay
            }}

            onChange={(event, newValue) => {
                handleSearchChange(newValue as Secretaria);
            }}


            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Secretaria"
                    required={required ? true : false}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading.current ? (
                                    <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}

        />
    );








}
export default TxtSecretaria;

